import { API_PRIVATE_HOST, API_PUBLIC_HOST } from "@/_constant";
import api from "./request"

export function updateListingStatus(listingId, status, message) {
    return new Promise(async (resolve, reject) => {
        try {
            const URL = `${API_PRIVATE_HOST}/listing/changeStateForListings?listId=${listingId}&listingStatus=${status}&message=${message}`;
            const res = await api.get(URL);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export function fetchListingWithAddons(requestData) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post(`${API_PUBLIC_HOST}/listing/listListingWithAddons`, requestData);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    });
}

export function fetchListingDetails(listingId){
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.get(`${API_PUBLIC_HOST}/listing/viewListing?listId=${listingId}`);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    });
}


export function fetchGreatDealListing(requestData) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post(`${API_PUBLIC_HOST}/banner/viewListingsInBanner`, requestData);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    });
}